import axios from 'axios';

const ApiNoToken = axios.create({
  // baseURL: "https://pok-unlifelike-debauchedly.ngrok-free.app/api",
  baseURL: 'https://apiworkorder.perumdamtkr.com/api',
  headers: {
    'ngrok-skip-browser-warning': 'any',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default ApiNoToken;
